import React from "react";
import Navbar from "../../Navbar/Navbar";
import Banner from "./Banner/Banner";
import classes from "../HomeScreen/HomeScreen.module.css";
import requests from "../../../Request";
import Row from "./Row";

const HomeScreen = () => {
  return (
    <div className={classes.homescreen}>
      <Navbar />
      <Banner />

      <Row
        title="NETFLIX ORIGINAL"
        fetchUrl={requests.fetchNetflixOriginals}
        isLargeRow={true}
      />
      <Row key="1" title="Trending Now" fetchUrl={requests.fetchTrending} />
      <Row key="2" title="Top Rated" fetchUrl={requests.fetchTopRated} />
      <Row
        key="3"
        title="Action Movies"
        fetchUrl={requests.fetchActionMovies}
      />
      <Row
        key="4"
        title="Comedy Movies"
        fetchUrl={requests.fetchComedyMovies}
      />
      <Row
        key="5"
        title="Horror Movies"
        fetchUrl={requests.fetchHorrorMovies}
      />
      <Row
        key="6"
        title="Romance Movies"
        fetchUrl={requests.fetchRomanceMovies}
      />
      <Row
        key="7"
        title="Documentaries"
        fetchUrl={requests.fetchDocumentaries}
      />
    </div>
  );
};

export default HomeScreen;
